/* import __COLOCATED_TEMPLATE__ from './organization-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();